import { authStore } from '@/stores';
import useLink from './useLink';
import { useMutation } from '@tanstack/react-query';
import { usersService, userConnectionService } from '@/modules/_core/services';

export const useJoinCommunityMutation = (communityId: string) => {
	const user = authStore.user;
	const { openDeepLink } = useLink();

	const { isLoading: isJoinCommunityLoading, mutate: handleJoinCommunity } = useMutation(
		async () => {
			if (!communityId) {
				return;
			}

			// Note: If user is logged in, we join/follow the community
			if (user?.id) {
				await userConnectionService.follow(communityId);

				return;
			}

			const chatInvitationCode = await usersService.getUserProfileChatInvitationCodePublic(communityId);

			openDeepLink({ isChatLink: true, inviteCode: chatInvitationCode });

			await new Promise(resolve => setTimeout(resolve, 2000));
		},
		{
			onError: error => {
				console.error('Error joining community:', error);
			},
		}
	);

	return { isJoinCommunityLoading, handleJoinCommunity };
};
